import { z } from 'zod';
import { nameSchema, paginationSchema } from './common.js';

/**
 * Storage location types
 */
export const STORAGE_LOCATION_TYPES = ['SHELF', 'BIN', 'CABINET', 'DRYER', 'OTHER'] as const;

/**
 * Create a new storage location
 */
export const createStorageLocationSchema = z.object({
  name: nameSchema,
  type: z.enum(STORAGE_LOCATION_TYPES).default('OTHER'),
  description: z.string().max(500).nullable().optional(),
  capacity: z.number().int().min(1).max(1000).nullable().optional(), // Max spools
});

export type CreateStorageLocationInput = z.infer<typeof createStorageLocationSchema>;

/**
 * Update an existing storage location
 */
export const updateStorageLocationSchema = createStorageLocationSchema.partial();

export type UpdateStorageLocationInput = z.infer<typeof updateStorageLocationSchema>;

/**
 * Query/filter schema for storage locations
 */
export const storageLocationQuerySchema = paginationSchema.extend({
  type: z.enum(STORAGE_LOCATION_TYPES).optional(),
  search: z.string().max(100).optional(),
  sortBy: z.enum(['name', 'type', 'createdAt']).default('name'),
  sortOrder: z.enum(['asc', 'desc']).default('asc'),
});

export type StorageLocationQuery = z.infer<typeof storageLocationQuerySchema>;
